import { SCOPES } from '../scopes.js';
import { botConfig } from '../types.js';

/**
 * Bot Fight Mode NIE jest ustawieniem strefy — żyje pod
 * `GET|PUT /zones/{id}/bot_management`, a PUT nadpisuje cały obiekt konfiguracji.
 *
 * `plans.max = 'free'` jest celowe: `fight_mode` to mechanizm planu Free.
 * Od Pro w górę odpowiednikiem są pola `sbfm_*` (Super Bot Fight Mode).
 * Bez `max` Etap 4 wysłałby `fight_mode: true` na strefę Pro, gdzie nic to nie zrobi.
 */
export const botFightMode = botConfig({
  field: 'fight_mode',
  value: { t: 'bool' },
  staff: {
    label: 'Bot Fight Mode',
    hint:
      'Tylko plan Free. Nie działa na Ruleset Engine, więc reguły skip/bypass go NIE omijają — ' +
      'nie da się zrobić wyjątku dla własnego API czy monitoringu.',
  },
  customer: {
    changePl: (v) =>
      v
        ? 'Włączymy podstawową ochronę przed automatami odwiedzającymi stronę.'
        : 'Wyłączymy podstawową ochronę przed automatami.',
  },
  plans: { min: 'free', max: 'free' },
  scopes: [SCOPES.zoneWafWrite],
  valueNotes: {
    true: {
      severity: 'warn',
      textPl:
        'Nie da się zrobić wyjątku dla wybranego ruchu. Jeśli klient ma własne API, ' +
        'monitoring lub integracje, rozważ zamiast tego Super Bot Fight Mode (Pro+).',
    },
  },
});
